import { FC } from 'react';

import { dispatch } from 'store';
import { prevRegisterStep } from 'modules/auth/actions';

import arrowLeft from 'assets/images/arrow-left.png';
import styles from './PrevStep.module.css';

import { t } from 'utils';
import texts from '../../../texts';

type Props = {
  step: number;
};

export const PrevStep: FC<Props> = ({ step }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <a className={styles.arrowLeft} onClick={() => dispatch(prevRegisterStep())}>
        <img src={arrowLeft} alt="arrow-left" />
      </a>
      <p style={{ marginLeft: '20px' }}>
        {t(texts.general.step)} {step} {t(texts.general.of)} 3
      </p>
    </div>
  );
};
